import { render, staticRenderFns } from "./TbcAddCard.vue?vue&type=template&id=3e4135ab&"
import script from "./TbcAddCard.vue?vue&type=script&lang=js&"
export * from "./TbcAddCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports